import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import FocusTrapper from 'ember-focus-trapper/components/focus-trapper';
import ModalDialog from 'garaje/components/ui/classic/modal-dialog';

interface BulkPreregistrationEmailConfirmationSignature {
  Args: {
    yes: () => void;
    no: () => void;
  };
}

export default <template>
  <ModalDialog @clickOutsideToClose={{false}} @targetAttachment="center" @translucentOverlay={{true}}>
    <FocusTrapper>
      <div data-test-bulk-preregistration-email-confirmation class="p-16">
        <h1>Do you want guests to pre-register?</h1>
        <p class="my-8">This lets them sign in more quickly when they arrive. Choose "Yes" to email guests an invitation
          with a link to pre-register.</p>
        <div>
          <button
            class="btn float-right ml-4 btn--small btn--brandOutlineFill"
            {{on "click" @yes}}
            type="button"
            data-test-bulk-preregistration-email-confirm-yes
          >
            Yes
          </button>
          <button
            class="ml-2 float-right btn btn--small btn--hoverFill"
            {{on "click" @no}}
            type="button"
            data-test-bulk-preregistration-email-confirm-no
          >
            No
          </button>
        </div>
      </div>
    </FocusTrapper>
  </ModalDialog>
</template> satisfies TOC<BulkPreregistrationEmailConfirmationSignature>;
